import React from 'react';
import { Hero } from '../components/landing/Hero';
import { ProblemSection } from '../components/landing/ProblemSection';
import { BeliefChange } from '../components/landing/BeliefChange';
import { ProgramExplanation } from '../components/landing/ProgramExplanation';
import { Results } from '../components/landing/Results';
import { Offer } from '../components/landing/Offer';
import { Guarantee } from '../components/landing/Guarantee';
import { FAQ } from '../components/landing/FAQ';
import { FinalCTA } from '../components/landing/FinalCTA';
export function LandingPage() {
  return <main className="min-h-screen w-full bg-cream overflow-x-hidden" data-id="element-149">
      <Hero data-id="element-150" />
      <ProblemSection data-id="element-151" />
      <BeliefChange data-id="element-152" />
      <ProgramExplanation data-id="element-153" />
      <Results data-id="element-154" />
      <Offer data-id="element-155" />
      <Guarantee data-id="element-156" />
      <FAQ data-id="element-157" />
      <FinalCTA data-id="element-158" />
    </main>;
}